module.exports = __webpack_public_path__ + "img/login.76cb962c.png";